import { Icon } from "@iconify/react";
import { IconButton, Typography, Stack } from "@mui/material";
import iconArrowBackOutline from "@iconify/icons-eva/arrow-back-outline";
import { useNavigate } from "react-router";


export default function NavBack({ title }) {
  const navigate = useNavigate();

  function handleBackClick() {
    navigate(-1, { replace: true });
  }

  return (
    <Stack direction="row" alignItems="center">
      <IconButton onClick={handleBackClick}>
        <Icon icon={iconArrowBackOutline} width={24} height={24} />
      </IconButton>
      { title && <Typography variant="h4" ml={1}>{title}</Typography> }
    </Stack>
  );
}
